import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

function authHeaders() {
  const token = localStorage.getItem('adeeb-token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function readUser() {
  try { return JSON.parse(localStorage.getItem('adeeb-user') || 'null'); } catch { return null; }
}

const Ctx = createContext({
  active: false,
  loading: true,
  role: null,
  refresh: () => {},
  gateOpen: false,
  gateReturnPath: null,
  openGate: () => {},
  closeGate: () => {},
});

export function SubscriptionProvider({ children }) {
  const [status, setStatus] = useState({ active: false, loading: true, role: null });
  const [gate, setGate]     = useState({ open: false, returnPath: null });

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('adeeb-token');
    if (!token) {
      setStatus({ active: false, loading: false, role: null });
      return;
    }
    const u = readUser();
    // Admins get a free pass — server-side requireActiveSubscription does the same.
    if (u && u.role === 'admin') {
      setStatus({ active: true, loading: false, role: 'admin' });
      return;
    }
    // Students, teachers and school admins are covered by their school's
    // subscription — no personal Stripe sub. Server-side requireActive-
    // Subscription bypasses these accountTypes too, so the gate must
    // also let them through client-side or premium pages won't render.
    if (u && (u.accountType === 'student' || u.accountType === 'teacher' || u.accountType === 'school')) {
      setStatus({ active: true, loading: false, role: u.accountType });
      return;
    }
    try {
      const { data } = await axios.get('/api/billing/status', { headers: authHeaders() });
      setStatus({ active: !!data.active, loading: false, role: u?.role || 'user' });
    } catch {
      setStatus({ active: false, loading: false, role: u?.role || 'user' });
    }
  }, []);

  useEffect(() => {
    refresh();
    const onAuth = () => refresh();
    window.addEventListener('adeeb-auth-change', onAuth);
    return () => window.removeEventListener('adeeb-auth-change', onAuth);
  }, [refresh]);

  const openGate  = useCallback((returnPath) => setGate({ open: true, returnPath: returnPath || null }), []);
  const closeGate = useCallback(() => setGate({ open: false, returnPath: null }), []);

  return (
    <Ctx.Provider value={{ ...status, refresh, gateOpen: gate.open, gateReturnPath: gate.returnPath, openGate, closeGate }}>
      {children}
    </Ctx.Provider>
  );
}

export function useSubscription() {
  return useContext(Ctx);
}
